import React from 'react';
import { Button } from 'atoms';
import { guides } from './static';
import LargeButton from '@/components/Views/Buttons';

const EsserGuide = () => (
    <div className='esser-guide'>
        <div className='esser-guide--wrapper'>
            <h2 className='esser-guide--title'>Muzology aligns with ESSER </h2>
            <p className='esser-guide--subhead'>
                Muzology is an SEL-aligned, evidence-based math intervention with a
                track record of success across diverse populations of learners.
                Muzology aligns with all ESSER allowable uses that pertain to learning
                interventions.
            </p>
            <div className='esser-guide--guides-table-container'>
                <div className='esser-guide--guides-table'>
                    <div className='esser-guide--guides-table-header'>
                        <div className='esser-guide--guides-table-row'>
                            <div className='esser-guide--guides-table-col'>
                                <p>Allowable Usage</p>
                                <img src='/assets/icons/check-circle-white.svg' />
                            </div>
                            <div className='esser-guide--guides-table-col'>
                                <p>Muzology Alignment</p>
                                <img src='/assets/icons/heart.svg' />
                            </div>
                        </div>
                    </div>
                    <div className='esser-guide--guides-table-body'>
                        {guides.map((row, index) => (
                            <div className='esser-guide--guides-table-row' key={index}>
                                <div className='esser-guide--guides-table-col'>
                                    <p>{row.usage}</p>
                                </div>
                                <div className='esser-guide--guides-table-col'>
                                    {row.alignment.map((item, index1) => (
                                        <div className='esser-guide--guides-content' key={index1}>
                                            <img src='/assets/icons/check-green.svg' />
                                            <p>{item}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className='esser-guide--download-section'>
                <p className='esser-guide--download-heading'>
                    Download Muzology’s White Paper to learn how to access ESSER funds
                    to acclerate your students’ math recovery!
                </p>
                <LargeButton
                    className='blue-button mx-auto'
                    innerClassName='px-10'
                    text='Download ESSER white paper'
                    href='/docs/TAP INTO ESSER FUNDING - A Roadmap to Using ESSER Funds to Accelerate Math Recovery (2021).pdf'
                    newTab={true}
                />
            </div>
            <div className='esser-guide--share-section'>
                <img
                    className='esser-guide--exclamation-mark'
                    src='/assets/icons/exclamation.svg'
                />
                <p className='esser-guide--share-heading'>
                    Share this document with your principal, district administrator,
                    district grant writer, or federal programs coordinator.
                </p>
            </div>
        </div>
        <style jsx>
            {`
                .esser-guide {
                    width: 100%;
                    background: #ffffff;
                    padding: 80px 60px;


                    .esser-guide--wrapper {
                        max-width: 1300px;
                        margin: 0 auto;

                        .esser-guide--title {
                            font-weight: 800;
                            font-size: 42px;
                            line-height: 48px;
                            text-align: center;
                            color: #121651;
                            margin: 0;
                        }

                        .esser-guide--subhead {
                            font-weight: 500;
                            font-size: 18px;
                            line-height: 25px;
                            color: #4f4f4f;
                            margin: 23px 0 0;
                        }

                        .esser-guide--guides-table-container {
                            margin: 40px 0 0;
                            width: 100%;
                            overflow-x: auto;

                            .esser-guide--guides-table {
                                min-width: 645px;
                                width: 100%;

                                .esser-guide--guides-table-row {
                                    display: flex;

                                    .esser-guide--guides-table-col {
                                        &:first-child {
                                            width: 32%;
                                            border-right: 3px solid #ffffff;
                                        }

                                        &:last-child {
                                            width: 68%;
                                        }
                                    }

                                    &:nth-child(odd) {
                                        .esser-guide--guides-table-col {
                                            background: #f7f7f7;
                                        }
                                    }

                                    &:nth-child(even) {
                                        .esser-guide--guides-table-col {
                                            background: #e9e9e9;
                                        }
                                    }
                                }

                                .esser-guide--guides-table-header {
                                    .esser-guide--guides-table-row {
                                        .esser-guide--guides-table-col {
                                            background: linear-gradient(90.01deg,
                                            #1cc8e1 0.01%,
                                            #1c9ae1 99.99%);
                                            display: flex;
                                            align-items: center;
                                            justify-content: center;
                                            padding: 17px 0;

                                            p {
                                                font-weight: bold;
                                                font-size: 24px;
                                                line-height: 33px;
                                                display: flex;
                                                align-items: center;
                                                text-align: center;
                                                color: #ffffff;
                                                margin: 0 11px 0 0;
                                            }
                                        }
                                    }
                                }

                                .esser-guide--guides-table-body {
                                    .esser-guide--guides-table-row {
                                        border-bottom: 3px solid #4f4f4f;

                                        &:last-child {
                                            border-bottom: none;
                                        }

                                        .esser-guide--guides-table-col {
                                            &:first-child {
                                                display: flex;
                                                align-items: center;
                                                padding: 0 48px;

                                                p {
                                                    font-weight: 800;
                                                    font-size: 18px;
                                                    line-height: 25px;
                                                    color: #4f4f4f;
                                                    margin: 0;
                                                }
                                            }

                                            &:last-child {
                                                padding: 33px 36px 33px 52px;

                                                .esser-guide--guides-content {
                                                    display: flex;
                                                    align-items: flex-start;

                                                    img {
                                                        margin-top: 5px;
                                                    }

                                                    p {
                                                        font-weight: 500;
                                                        font-size: 18px;
                                                        line-height: 25px;
                                                        color: #4f4f4f;
                                                        margin: 0;
                                                        padding: 0 10px 14px;
                                                    }

                                                    &:last-child {
                                                        p {
                                                            padding-bottom: 0;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        .esser-guide--download-section {
                            padding: 30px 0 22px;
                            max-width: 966px;
                            background-image: url('/assets/graphics/ellipse-6.svg');
                            background-size: contain;
                            background-repeat: no-repeat;
                            background-position: center;
                            margin: 77px auto 0;
                            display: flex;
                            flex-direction: column;
                            align-items: center;

                            .esser-guide--download-heading {
                                font-weight: 800;
                                font-size: 32px;
                                line-height: 39px;
                                text-align: center;
                                color: #1c9ae1;
                                margin: 0 0 27px;
                            }
                        }

                        .esser-guide--share-section {
                            display: flex;
                            align-items: center;
                            max-width: 600px;
                            margin: 23px auto 0;

                            .esser-guide--share-heading {
                                font-weight: 800;
                                font-size: 18px;
                                line-height: 25px;
                                color: #e637a8;
                                margin: 0 0 0 18px;
                            }
                        }
                    }

                    @media (max-width: 992px) {
                        padding: 80px 40px;

                        .esser-guide--wrapper {
                            .esser-guide--guides-table-container {
                                margin-top: 50px;

                                .esser-guide--guides-table {
                                    .esser-guide--guides-table-header {
                                        .esser-guide--guides-table-row {
                                            .esser-guide--guides-table-col {
                                                p {
                                                    font-size: 20px;
                                                }

                                                img {
                                                    height: 24px;
                                                }
                                            }
                                        }
                                    }

                                    .esser-guide--guides-table-body {
                                        .esser-guide--guides-table-row {
                                            .esser-guide--guides-table-col {
                                                &:first-child {
                                                    padding: 25px;

                                                    p {
                                                        font-size: 16px;
                                                    }
                                                }

                                                &:last-child {
                                                    padding: 25px 35px;

                                                    .esser-guide--guides-content {
                                                        img {
                                                            width: 15px;
                                                        }

                                                        p {
                                                            font-size: 16px;
                                                            padding: 0 10px 8px;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    @media (max-width: 768px) {
                        padding: 80px 20px;

                        .esser-guide--wrapper {
                            .esser-guide--title {
                                font-size: 36px;
                            }

                            .esser-guide--subhead {
                                font-size: 16px;
                            }

                            .esser-guide--guides-table-container {
                                margin-top: 50px;

                                .esser-guide--guides-table {
                                    .esser-guide--guides-table-header {
                                        .esser-guide--guides-table-row {
                                            .esser-guide--guides-table-col {
                                                p {
                                                    font-size: 18px;
                                                }

                                                img {
                                                    height: 22px;
                                                }
                                            }
                                        }
                                    }

                                    .esser-guide--guides-table-body {
                                        .esser-guide--guides-table-row {
                                            .esser-guide--guides-table-col {
                                                &:first-child {
                                                    padding: 25px;

                                                    p {
                                                        font-size: 16px;
                                                    }
                                                }

                                                &:last-child {
                                                    padding: 25px;

                                                    .esser-guide--guides-content {
                                                        img {
                                                            width: 15px;
                                                        }

                                                        p {
                                                            font-size: 16px;
                                                            padding: 0 10px 8px;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            .esser-guide--download-section {
                                margin-top: 40px;
                                max-width: 550px;

                                .esser-guide--download-heading {
                                    font-size: 28px;
                                }
                            }

                            .esser-guide--share-section {
                                .esser-guide--share-heading {
                                    font-size: 16px;
                                }
                            }
                        }
                    }

                    @media (max-width: 480px) {
                        padding: 48px 20px;

                        .esser-guide--wrapper {
                            .esser-guide--share-section {
                                flex-direction: column;

                                .esser-guide--share-heading {
                                    margin: 10px 0 0;
                                    text-align: center;
                                }
                            }
                        }
                    }
                }
            `}
        </style>
    </div>
);

export default EsserGuide;
